<app-image-thumbnail [size]="size()">
  <img
    [fill]="true"
    [ngSrc]="AssetImage.MultimediaBroken | assetImageUrl"
    alt="Nieobsługiwany podgląd pliku."
    title="Nieobsługiwany podgląd pliku." />
</app-image-thumbnail>
